import i18n from "../../../../utils/i18n";

const CegjelzoSearchHeader = ({ titleClassName, subtitleClassName }) => (
  <>
    <h1 className={titleClassName}>{i18n.t("searchflow.headertitle")}</h1>
    <p className={subtitleClassName}>
      {i18n.t("searchflow.headersubtitle")}
    </p>
  </>
);

export default CegjelzoSearchHeader;
